import { PostProperties } from "./types";

// Exposés
import exposeZemna from "./exposes/expose-zemna";
import exposeArchon from "./exposes/expose-archon";
import exposeMagister from "./exposes/expose-magister";
import exposeWanderbursche from "./exposes/expose-wanderbursche";
import exposeSneakySneaks from "./exposes/expose-sneaky-sneaks";
import exposeIliyanTomov from "./exposes/expose-iliyan-tomov";
import exposeModernAbuse from "./exposes/expose-modern-abuse";
import exposeTotenmet from "./exposes/expose-totenmet";
import exposeMarkov from "./exposes/expose-markov";
import exposeVertex from "./exposes/expose-vertex";
import exposeMarthen from "./exposes/expose-marthen";
import exposeDvorjack from "./exposes/expose-dvorjack";

// Lost Gems
import lostGemBasMooy from "./lost-gems/lost-gem-bas-mooy";
import lostGemMarthen from "./lost-gems/lost-gem-marthen";
import lostGemAaronCarl from "./lost-gems/lost-gem-aaron-carl";
import lostGemLukeSlater from "./lost-gems/lost-gem-luke-slater";
import lostGemDeltaFunktionen from "./lost-gems/lost-gem-delta-funktionen";
import lostGemKevinSaunderson from "./lost-gems/lost-gem-kevin-saunderson";
import lostGemDelanoSmith from "./lost-gems/lost-gem-delano-smith";
import lostGemMikeHuckaby from "./lost-gems/lost-gem-mike-huckaby";
import lostGemReeko from "./lost-gems/lost-gem-reeko";
import lostGemSvreca from "./lost-gems/lost-gem-svreca";
import lostGemRodhad from "./lost-gems/lost-gem-rodhad";
import lostGemDjStingray from "./lost-gems/lost-gem-dj-stingray";
import lostGemDrumcell from "./lost-gems/lost-gem-drumcell";
import lostGemSandwellDistrict from "./lost-gems/lost-gem-sandwell-district";
import lostGemCosminTrg from "./lost-gems/lost-gem-cosmin-trg";
import lostGemTakaakiItoh from "./lost-gems/lost-gem-takaaki-itoh";
import lostGemPaulJohnson from "./lost-gems/lost-gem-paul-johnson";
import lostGemDvs1 from "./lost-gems/lost-gem-dvs1";
import lostGemDustinZahn from "./lost-gems/lost-gem-dustin-zahn";
import lostGemConvextion from "./lost-gems/lost-gem-convextion";
import lostGemJeffMills from "./lost-gems/lost-gem-jeff-mills";
import lostGemAndrewWeatherall from "./lost-gems/lost-gem-andrew-weatherall";
import lostGemRicardoVillalobos from "./lost-gems/lost-gem-ricardo-villalobos";
import lostGemSpencerKincy from "./lost-gems/lost-gem-spencer-kincy";
import lostGemJeromeSydenham from "./lost-gems/lost-gem-jerome-sydenham";
import lostGemSteveBicknell from "./lost-gems/lost-gem-steve-bicknell";
import lostGemFrequency7 from "./lost-gems/lost-gem-frequency-7";
import lostGemStaceyPullen from "./lost-gems/lost-gem-stacey-pullen";
import lostGemConforce from "./lost-gems/lost-gem-conforce";
import lostGemCollabs3000 from "./lost-gems/lost-gem-collabs-3000";
import lostGemSurgeon from "./lost-gems/lost-gem-surgeon";
import lostGemDerrickCarter from "./lost-gems/lost-gem-derrick-carter";
import lostGemSpeedyJ from "./lost-gems/lost-gem-speedy-j";
import exposeXander from "./exposes/expose-xander";

export type {
  QuestionAndAnswer,
  PostTranslationBg,
  PostProperties,
} from "./types";
export { resolvePost } from "./types";

export const posts: PostProperties[] = [
  exposeDvorjack, // id: 46
  exposeXander, // id: 45
  lostGemSpeedyJ, // id: 44
  lostGemDerrickCarter, // id: 43
  lostGemSurgeon, // id: 42
  lostGemCollabs3000, // id: 41
  lostGemConforce, // id: 40
  lostGemStaceyPullen, // id: 39
  lostGemFrequency7, // id: 38
  lostGemSteveBicknell, // id: 37
  lostGemJeromeSydenham, // id: 36
  lostGemSpencerKincy, // id: 35
  lostGemRicardoVillalobos, // id: 34
  lostGemAndrewWeatherall, // id: 33
  lostGemJeffMills, // id: 32
  lostGemConvextion, // id: 31
  lostGemDustinZahn, // id: 30
  lostGemBasMooy, // id: 29
  exposeZemna, // id: 28
  exposeArchon, // id: 27
  exposeMagister, // id: 26
  exposeWanderbursche, // id: 25
  lostGemMarthen, // id: 24
  lostGemAaronCarl, // id: 23
  lostGemLukeSlater, // id: 22
  lostGemDeltaFunktionen, // id: 21
  lostGemKevinSaunderson, // id: 20
  lostGemDelanoSmith, // id: 19
  lostGemMikeHuckaby, // id: 18
  lostGemReeko, // id: 17
  lostGemSvreca, // id: 16
  lostGemRodhad, // id: 15
  lostGemDjStingray, // id: 14
  lostGemDrumcell, // id: 13
  lostGemSandwellDistrict, // id: 12
  lostGemCosminTrg, // id: 11
  lostGemTakaakiItoh, // id: 10
  lostGemPaulJohnson, // id: 9
  lostGemDvs1, // id: 8
  exposeSneakySneaks, // id: 7
  exposeIliyanTomov, // id: 6
  exposeModernAbuse, // id: 5
  exposeTotenmet, // id: 4
  exposeMarkov, // id: 3
  exposeVertex, // id: 2
  exposeMarthen, // id: 1
];
